import Joi from 'joi-full';
import { formValueSelector } from 'redux-form';

import { syncValidateData } from '../../../../common/validator';
import { getAssignedTotal } from '../FormSteps/InventoryStep/InventoryStepContainer';
import * as selectors from '../../selectors';

export const PRODUCT_FORM_NAME = 'productForm';

const schema = context => Joi.object().keys({
  id: Joi.string().guid().optional(),
  name: Joi.string().min(2).required(),
  desc: Joi.string().min(2).optional().allow('', null),
  price: Joi.number().min(0).required(),
  supplyPrice: Joi.number().min(0).optional(),
  salesPrice: Joi.number().min(0).optional(),
  inventory: Joi
    .when('action', {
      is: Joi.number().min(0),
      then: Joi.number().min(Joi.ref('$assignedInventory')),
      otherwise: Joi.number()
        .min(0)
        .required(),
    })
    .options({
      language: {
        number: {
          min: `must be greater than ${context.assignedInventory} assigned inventory count`,
        },
      },
    }).required(),
  inventoryAlertAmount: Joi.number().min(0).optional(),
  productCategoryId: Joi.string().guid().optional().allow(null),
  productBrandId: Joi.string().guid().optional().allow(null),
  sku: Joi.string().optional().allow(null, ''),
  tax: Joi.array().items(Joi.string().guid()).optional().allow([]),
  isRetail: Joi.boolean().label('Retail'),
  lowInventoryThreshold: Joi.number().min(0).optional().label('Low inventory'),
  highInventoryThreshold: Joi.number().min(0).optional().allow(null)
    .when('lowInventoryThreshold', {
      is: Joi.number().min(1),
      then: Joi.number().greater(Joi.ref('lowInventoryThreshold')).optional().allow(null),
    })
    .label('High inventory'),
  locationPrice: Joi.number().min(0).optional().label('Price'),
  assignments: Joi.object().pattern(
    /^[\w-]+$/,
    Joi.object().keys({
      enabled: Joi.boolean().required(),
      inventory: Joi.when('enabled', {
        is: Joi.boolean().invalid(false),
        then: Joi.number().min(0).required(),
      }).label('Inventory'),
      lowInventoryThreshold: Joi.when('enabled', {
        is: Joi.boolean().invalid(false),
        then: Joi.number().min(0).optional().allow(null),
      }).label('Low inventory'),
      highInventoryThreshold: Joi.when('enabled', {
        is: Joi.boolean().invalid(false),
        then: Joi.number().min(0).optional().allow(null)
          .when('lowInventoryThreshold', {
            is: Joi.number().min(1),
            then: Joi.number().greater(Joi.ref('lowInventoryThreshold')).optional().allow(null),
          }),
      }).label('High inventory'),
      price: Joi.when('enabled', {
        is: Joi.boolean().invalid(false),
        then: Joi.number().min(0).optional().allow(null),
      }).label('Price'),
    }),
  ),
});

export const validateProductForm = (values, props) => {
  const unallocatedInventory = props.inventory - getAssignedTotal(values.assignments);
  const context = {
    assignedInventory: selectors.getAssignmentsInventory(values),
    unallocatedInventory: unallocatedInventory >= 0 ? unallocatedInventory : 0,
  };

  return syncValidateData(values, schema(context), { context });
};

export const productFormValueSelector = formValueSelector(PRODUCT_FORM_NAME);
